import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface StatCardProps {
  title: string;
  value: string;
  change: number;
  subtitle: string;
  isLoading?: boolean;
  displayChange?: boolean;
}

const StatCard = ({ title, value, change, subtitle, isLoading, displayChange = false }: StatCardProps) => {
  const isPositive = change >= 0;

  return (
    <div className="bg-card rounded-xl p-5 border border-border">
      <p className="text-sm text-muted-foreground mb-2">{title}</p>
      {isLoading ? (
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-3 w-16" />
          </div>
          <Skeleton className="h-7 w-14 rounded-full" />
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <div>
            <p className="text-2xl font-bold text-foreground">{value}</p>
            <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
          </div>
          
          {displayChange && (
          <div
            className={cn(
              "flex items-center gap-1 px-2 py-1 rounded-full text-sm font-medium",
              isPositive
                ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400"
                : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400"
            )}
          >
            {isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            {`${Math.abs(change)}%`}
          </div>
          )}

        </div>
      )}
    </div>
  );
};

export default StatCard;
